import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { I as Input } from '../Input/Input-BUUIyoVs.js';
import { g as getCurrencySymbol } from './getCurrencySymbol-DBeSyx5v.js';
import { g as getCurrencyPosition } from './getCurrencyPosition-CbH4B-Ek.js';
import { p as parseIetfLanguageTag } from './parseIetfLanguageTag-Ce4WxX-q.js';

const CurrencyInput = ({
  id,
  currency,
  locale,
  type = 'number',
  ariaLabel,
  ...rest
}) => {
  if (!currency || !locale) {
    return /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
      id: id,
      type: type,
      ariaLabel: ariaLabel
    }));
  }
  let currencySymbol;
  let currencyPosition;
  if (typeof Intl !== 'undefined') {
    var _Intl$NumberFormat;
    const parts = (_Intl$NumberFormat = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    })) === null || _Intl$NumberFormat === void 0 ? void 0 : _Intl$NumberFormat.formatToParts(0);
    if (parts && parts.length) {
      var _parts;
      currencyPosition = 'prefix';
      currencySymbol = parts[0].value;
      if (((_parts = parts[parts.length - 1]) === null || _parts === void 0 ? void 0 : _parts.type) === 'currency') {
        var _parts2;
        currencySymbol = (_parts2 = parts[parts.length - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.value;
        currencyPosition = 'suffix';
      }
    }
  }

  // Since the AdsConsole does not have en-ZA as a locale, we must force 'ZAR' to map to 'R'. The above code
  // block resolves all other 'en-*' locales to ZAR.
  if (!currencySymbol || currencySymbol === 'ZAR') {
    const {
      language,
      country
    } = parseIetfLanguageTag(locale);
    currencySymbol = getCurrencySymbol(currency);
    currencyPosition = getCurrencyPosition(language, country);
  }
  let prefix = null;
  let suffix = null;
  if (currencySymbol && currencyPosition) {
    if (currencyPosition === 'prefix') {
      prefix = currencySymbol;
    } else {
      suffix = currencySymbol;
    }
  }
  return /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, {
    id: id,
    type: type,
    prefix: prefix,
    suffix: suffix,
    ariaLabel: ariaLabel || `enter amount in ${currencySymbol}`,
    ignoreTextDirection: true
  }));
};

export { CurrencyInput as C };
//# sourceMappingURL=CurrencyInput-CDdLlM-Q.js.map
